export const SITE_URL = 'AIzaSyAZIMcNG99uRd8bQCU70979K2SXmf5FdCE';
export const GMAPS_API_KEY = 'AIzaSyAZIMcNG99uRd8bQCU70979K2SXmf5FdCE';
export const POWERED_BY_AFFILIATE_KEY = 'EBAA85DE-BBA9-4190-8C4D-11DAC46B7948';
export const POWERED_BY_AFFILIATE_REF = '174p';
export const POWERED_BY_END_POINT =
  'https://poweredby.loanfinder.co.uk/cascadeCustomer.php?';
export const IPIFY_ENDPOINT = 'https://api.ipify.org';
export const SCOUT_URL = 'https://scout.ratio.zone/simple';
